// extracted by mini-css-extract-plugin
export default {"wrapper":"j3-z","play":"k3-z"};